import React, { Component } from 'react';
import MainMenuButton from './control/MainMenuButton';

import { IsFunctionOpen, MenuConfig } from '../conf/Config'
import { Events, JSEvent } from '../utils/JSEvent';

class MainMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSelect: "wallet"
        }
    }

    componentDidMount() {
        this.onItemSelected(MenuConfig[0].name, MenuConfig[0]);
        JSEvent.on(Events.MainMenu.SwitchMenu, (evt) => {
            //menu 是 Config.MainMenu.name
            MenuConfig.forEach(cfg => {
                const { menu, args } = evt;
                if (cfg.name == menu) {
                    this.onItemSelected(menu, cfg, args);
                }
            })
        })
    }

    onItemSelected(itemName, cfg, params) {

        this.setState({ currentSelect: itemName });

        let { onSelected } = this.props;
        if (onSelected != null) {
            onSelected(itemName, cfg, params);
        }
    }

    render() {
        let items = [];
        MenuConfig.forEach(cfg => {
            if (IsFunctionOpen(cfg.name)) {
                items.push(<MainMenuButton key={cfg.name} {...cfg}
                    selected={this.state.currentSelect == cfg.name}
                    onClick={itemName => this.onItemSelected(cfg.name, cfg)}
                />)
            }
        });

        const topIcon = <div className=' h-14' />

        return (
            // <div className="w-24 flex flex-col bg-menu-bg-dark"></div>
            <div className="flex w-full h-[64px]">
                {items}
            </div>
        );
    }
}

export default MainMenu;